import { Injectable } from '@angular/core';

import { IBitfUiRoleManagerService } from '@interfaces';
import { ERoleActions, EFsType } from '@enums';
import { StoreService } from '@services';
import { FsStore } from '@models';
import { ReturnStatement } from '@angular/compiler';

@Injectable({
  providedIn: 'root',
})
export class UiRoleManagerService implements IBitfUiRoleManagerService {
  constructor(private storeService: StoreService) {}

  canI(action, data?: { fsStore: FsStore }): boolean {
    switch (action) {
      /* COUPON */
      case ERoleActions.COUPON_GENERATE:
        return this.storeService.store.user.canGenerateCoupon;
      case ERoleActions.COUPON_BURN:
        return this.storeService.store.user.canBurnCoupon;
      case ERoleActions.ANONYMIZE_DATA:
        return this.storeService.store.user.canAnonymizeData;
      case ERoleActions.COUPON_GENERATE_UNLIMITED:
        return this.storeService.store.user.canGenerateUnlimitedCoupon;
      case ERoleActions.MANAGE_JOBS:
        return this.storeService.store.user.canManageJobs;
      /**
       * VIEW PAGES
       */
      case ERoleActions.VIEW_HOME:
        return this.storeService.store.user.canViewHome;
      case ERoleActions.VIEW_DOCUMENT_ARCHIVE:
        return this.storeService.store.user.canViewDocumentArchive;
      case ERoleActions.VIEW_SETTINGS:
        return this.storeService.store.user.canViewSettings;
      case ERoleActions.VIEW_NEWS_SETTINGS:
        return this.storeService.store.user.canViewNewsSettings;
      case ERoleActions.VIEW_CALENDAR_SETTINGS:
        return this.storeService.store.user.canViewCalendarSettings;
      case ERoleActions.VIEW_TAG_SETTINGS:
        return this.storeService.store.user.canViewTagSettings;

      /**
       * FILE SYSTEM
       */
      case ERoleActions.CREATE_FOLDER:
        switch (data.fsStore.configuration.name) {
          case EFsType.DOCUMENT_FS:
            return this.storeService.store.user.canEditDocument;
          default:
            return false;
        }

      case ERoleActions.OVERRIDE_FILE:
        switch (data.fsStore.configuration.name) {
          case EFsType.DOCUMENT_FS:
            return this.storeService.store.user.canEditDocument;
          default:
            return false;
        }

      case ERoleActions.UPLOAD_FILE:
        switch (data.fsStore.configuration.name) {
          case EFsType.DOCUMENT_FS:
            return this.storeService.store.user.canEditDocument;
          default:
            return false;
        }

      case ERoleActions.RENAME:
        switch (data.fsStore.configuration.name) {
          case EFsType.DOCUMENT_FS:
            return this.storeService.store.user.canEditDocument;
          default:
            return false;
        }

      case ERoleActions.DELETE:
        switch (data.fsStore.configuration.name) {
          case EFsType.DOCUMENT_FS:
            return this.storeService.store.user.canEditDocument;
          default:
            return false;
        }

      case ERoleActions.DOWNLOAD:
        return true;

      case ERoleActions.SHOW_TAG:
        if (data.fsStore.configuration.name === EFsType.DOCUMENT_FS) {
          return this.storeService.store.user.canEditDocument;
        }
        return false;

      case ERoleActions.SEARCH:
        return true;
      case ERoleActions.FILTER:
        return true;

      default:
        return false;
    }
  }
}
